import { PlusIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { SplitButton } from "@vega-core/components/SplitButton/SplitButton";
import { m } from "@vega-core/paraglide/messages";

type UnsavedChangesBarProps = {
  changeCount: number;
  isUploadActive?: boolean;
  onAddDocument: () => void;
  onDiscard: () => void;
  onSave: () => void;
  onCreateFolder: () => void;
  isSaving: boolean;
};

export function UnsavedChangesBar({
  changeCount,
  isUploadActive = false,
  onAddDocument,
  onDiscard,
  onSave,
  onCreateFolder,
  isSaving,
}: UnsavedChangesBarProps) {
  const hasChanges = changeCount > 0;
  const isDisabled = isSaving || isUploadActive;

  return (
    <div
      aria-atomic="true"
      aria-live="polite"
      className="flex flex-wrap items-center gap-3 border-b border-border/primary bg-background/secondary px-4 py-2.5"
      data-testid="data-room-unsaved-changes-bar"
      role="status"
    >
      {hasChanges ? (
        <span className="body-base-regular text-text/secondary">
          {m.coInvestments_dataRoom_unsavedChanges({ count: changeCount })}
        </span>
      ) : null}
      <div className="flex-1" />
      {hasChanges ? (
        <>
          <ThemedButton
            dataTestId="data-room-discard"
            disabled={isSaving}
            onClick={onDiscard}
            size="small"
            variant="secondary"
          >
            {m.coInvestments_dataRoom_discard()}
          </ThemedButton>
          <ThemedButton
            dataTestId="data-room-save"
            disabled={isDisabled}
            onClick={onSave}
            size="small"
            variant="primary"
          >
            {isSaving
              ? m.coInvestments_dataRoom_saving()
              : m.coInvestments_dataRoom_saveChanges()}
          </ThemedButton>
        </>
      ) : null}
      <SplitButton
        action={{
          icon: <PlusIcon className="size-4" />,
          label: m.coInvestments_dataRoom_addDocument(),
          onClick: onAddDocument,
          dataTestId: "data-room-add-document",
        }}
        menuItems={[
          {
            label: m.coInvestments_dataRoom_addDocument(),
            onSelect: onAddDocument,
          },
          {
            label: m.coInvestments_dataRoom_createFolder(),
            onSelect: onCreateFolder,
          },
        ]}
      />
    </div>
  );
}
